// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.topContainer {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 80px;
  }
  
  .icon-image {
    height: 2.4em;
    width: 2.4em;
    object-fit: contain;
  }
  
  
  
  .article {
    height: 100%;
    position: sticky;
    overflow: hidden;
  }
  
  .image {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
  
  .header {
    font-size: 60px;
    color: white;
    text-align: start;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 60px;
    width: 50%;
    margin-top: 18%;
    font-weight: bold;
    margin-left: 5%;
    font-family: AktivGroteskExtendedBold;
  }
  
  .headerL {
    font-size: 50px;
    color: white;
    text-align: end;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: fit-content;
    margin: auto;
  }
  
  .container .box {
    display: flex;
    flex-direction: row;
  }
  
  
  .container .box .box-cell.box1 {
    background: green;
    color: white;
    text-align: justify;
  }
  
  .container .box .box-cell.box2 {
    background: lightgreen;
    text-align: justify
  }
  
  .login-floating {
    width: 400px;
    height: 300px;
    background-color: white;
    text-align: center;
    position: absolute;
    right: 0;
    top: 0;
    margin-top: 10%;
    margin-right: 2%;
  }
  
  .login-niq-logo {
    width: 180px;
    margin-left: 22px;
    margin-top: 30px;
    padding-bottom: 45px;
    margin-right: 20px;
  }
  
  .email-login {
    font-size: 16px;
    height: 40px;
    width:80%;
  }
  .text-login{
    font-size: 16px;
    font-weight: bold;
    text-align: start;
    width:80%;
    margin-left: 10%;
    margin-bottom: 2%;
    font-family :"Aktiv Grotesk",sans-serif;
  
  }
  
  .btn-login {
    background-color: #000000;
    color: #ffffff;
    font-weight: bold;
    font-size: 13px;
    height: 40px;
    width:80%;
    margin-top: 10%;
  }
  .btn-login:hover{
    background-color: #00FE00;
    color: #000000;
  
  }
  .maincommondiv{
    /* text-align: center; */
    display: flex;
    justify-content: center;
  
  }
  .landingpagemaindiv{
    width: 1000px;
    height: 100%;
    display: inline-block;
    text-align: center;
    margin-top: 80px;
    justify-content: center;
    /* margin-left: 10%; */
  }
  .appmodulepanelLanding {
    position: relative;
    display: inline-block !important;
    width: 80px;
    height: 100px;
    margin: 40px 80px;
    text-align: center;
    cursor: pointer;
    background-color: transparent;
    border-radius: 10%;
  }
  .disabledModule {
    opacity: 0.5;               
    filter: grayscale(100%);     
    transition: opacity 0.3s ease;
  }
  
  .module_name_label {
    text-align: center;
    font: bold normal 12px "Aktiv Grotesk","Montserrat Regular",Sans-Serif;
    letter-spacing: 0;
    color: #000;
    opacity: 1;
    overflow: hidden;
    margin-top: 10px;
    width: 140px !important;
    height: 28px !important;
  }
  .landingPageHeading{
    font-size: 17px;
    font-weight: bolder;
    color: #000000;
    margin-top: 20px;
  }
  .gridpanelImageLanding {
    background-color: #fff;
    width: calc(100% - 2.5rem);
    height: auto;
    border-radius: 4px;
    margin-top: 0;
    border: 5px solid #fff;
  }
  .imageDiv {
    position: relative; /* Needed for absolute positioning inside */
    box-shadow: 0 0 3px #666;
    width: 150px;
    height: 165px;
    background-color: #fff;
    padding: 7px 5px 7px 5px;
  }
  
  .status-dot-container {
    position: absolute;
    top: 5px;
    right: 5px;
    z-index: 10;
  }
  
  .status-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
  }
  
  .status-dot.green {
    background-color: green;
  }
  
  .status-dot.yellow {
    background-color: yellow;
  }
  
  .status-dot.red {
    background-color: red;
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/AppHome/AppHome.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,mBAAmB;EACrB;;;;EAIA;IACE,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,UAAU;IACV,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,qCAAqC;EACvC;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,OAAO;IACP,QAAQ;IACR,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;;EAGA;IACE,iBAAiB;IACjB,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB;EACF;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,SAAS;EACX;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,uCAAuC;;EAEzC;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,SAAS;IACT,eAAe;EACjB;EACA;IACE,yBAAyB;IACzB,cAAc;;EAEhB;EACA;IACE,wBAAwB;IACxB,aAAa;IACb,uBAAuB;;EAEzB;EACA;IACE,aAAa;IACb,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,sBAAsB;EACxB;EACA;IACE,kBAAkB;IAClB,gCAAgC;IAChC,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,6BAA6B;IAC7B,kBAAkB;EACpB;EACA;IACE,YAAY;IACZ,uBAAuB;IACvB,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,sEAAsE;IACtE,iBAAiB;IACjB,WAAW;IACX,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,gBAAgB;EAClB;EACA;IACE,sBAAsB;IACtB,0BAA0B;IAC1B,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,kBAAkB,EAAE,2CAA2C;IAC/D,wBAAwB;IACxB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,qBAAqB;EACvB","sourcesContent":[".topContainer {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    margin-top: 80px;\n  }\n  \n  .icon-image {\n    height: 2.4em;\n    width: 2.4em;\n    object-fit: contain;\n  }\n  \n  \n  \n  .article {\n    height: 100%;\n    position: sticky;\n    overflow: hidden;\n  }\n  \n  .image {\n    object-fit: cover;\n    width: 100%;\n    height: 100%;\n  }\n  \n  .header {\n    font-size: 60px;\n    color: white;\n    text-align: start;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    height: 60px;\n    width: 50%;\n    margin-top: 18%;\n    font-weight: bold;\n    margin-left: 5%;\n    font-family: AktivGroteskExtendedBold;\n  }\n  \n  .headerL {\n    font-size: 50px;\n    color: white;\n    text-align: end;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    height: fit-content;\n    margin: auto;\n  }\n  \n  .container .box {\n    display: flex;\n    flex-direction: row;\n  }\n  \n  \n  .container .box .box-cell.box1 {\n    background: green;\n    color: white;\n    text-align: justify;\n  }\n  \n  .container .box .box-cell.box2 {\n    background: lightgreen;\n    text-align: justify\n  }\n  \n  .login-floating {\n    width: 400px;\n    height: 300px;\n    background-color: white;\n    text-align: center;\n    position: absolute;\n    right: 0;\n    top: 0;\n    margin-top: 10%;\n    margin-right: 2%;\n  }\n  \n  .login-niq-logo {\n    width: 180px;\n    margin-left: 22px;\n    margin-top: 30px;\n    padding-bottom: 45px;\n    margin-right: 20px;\n  }\n  \n  .email-login {\n    font-size: 16px;\n    height: 40px;\n    width:80%;\n  }\n  .text-login{\n    font-size: 16px;\n    font-weight: bold;\n    text-align: start;\n    width:80%;\n    margin-left: 10%;\n    margin-bottom: 2%;\n    font-family :\"Aktiv Grotesk\",sans-serif;\n  \n  }\n  \n  .btn-login {\n    background-color: #000000;\n    color: #ffffff;\n    font-weight: bold;\n    font-size: 13px;\n    height: 40px;\n    width:80%;\n    margin-top: 10%;\n  }\n  .btn-login:hover{\n    background-color: #00FE00;\n    color: #000000;\n  \n  }\n  .maincommondiv{\n    /* text-align: center; */\n    display: flex;\n    justify-content: center;\n  \n  }\n  .landingpagemaindiv{\n    width: 1000px;\n    height: 100%;\n    display: inline-block;\n    text-align: center;\n    margin-top: 80px;\n    justify-content: center;\n    /* margin-left: 10%; */\n  }\n  .appmodulepanelLanding {\n    position: relative;\n    display: inline-block !important;\n    width: 80px;\n    height: 100px;\n    margin: 40px 80px;\n    text-align: center;\n    cursor: pointer;\n    background-color: transparent;\n    border-radius: 10%;\n  }\n  .disabledModule {\n    opacity: 0.5;               \n    filter: grayscale(100%);     \n    transition: opacity 0.3s ease;\n  }\n  \n  .module_name_label {\n    text-align: center;\n    font: bold normal 12px \"Aktiv Grotesk\",\"Montserrat Regular\",Sans-Serif;\n    letter-spacing: 0;\n    color: #000;\n    opacity: 1;\n    overflow: hidden;\n    margin-top: 10px;\n    width: 140px !important;\n    height: 28px !important;\n  }\n  .landingPageHeading{\n    font-size: 17px;\n    font-weight: bolder;\n    color: #000000;\n    margin-top: 20px;\n  }\n  .gridpanelImageLanding {\n    background-color: #fff;\n    width: calc(100% - 2.5rem);\n    height: auto;\n    border-radius: 4px;\n    margin-top: 0;\n    border: 5px solid #fff;\n  }\n  .imageDiv {\n    position: relative; /* Needed for absolute positioning inside */\n    box-shadow: 0 0 3px #666;\n    width: 150px;\n    height: 165px;\n    background-color: #fff;\n    padding: 7px 5px 7px 5px;\n  }\n  \n  .status-dot-container {\n    position: absolute;\n    top: 5px;\n    right: 5px;\n    z-index: 10;\n  }\n  \n  .status-dot {\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n  }\n  \n  .status-dot.green {\n    background-color: green;\n  }\n  \n  .status-dot.yellow {\n    background-color: yellow;\n  }\n  \n  .status-dot.red {\n    background-color: red;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
